import React from 'react';
import { Shield } from 'lucide-react';
const HERO_BG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/training-bg.jpeg?opt=w3';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-781">
      <img src={HERO_BG} alt="Law Enforcement Training" className="block absolute inset-0 w-full h-full object-cover" onError={e => {
      e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/6VNDFTEeWuRsoQPUmRUT27/law1.jpg';
    }} data-id="element-782" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-783" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-784">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-785">
          <Shield className="w-4 h-4" data-id="element-786" />
          Specialized Training
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-787">
          Law Enforcement Training <br className="hidden md:block" data-id="element-788" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-teal-light" data-id="element-789">
            And Our Capabilities
          </span>
        </h1>
        <p className="text-lg md:text-xl text-brand-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-790">
          Two decades of reality-based training, use-of-force consulting, and
          legal expertise — delivered by professionals who have lived the work
          they teach.
        </p>
      </div>
    </section>;
}